import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { GenericFormUICCreateRequestDTO, GenericFormUICDeleteRequestDTO, GenericFormUICDTO, GenericFormUICList, GenericFormUICReadAllRequestDTO, GenericFormUICReadByTenantIdRequestDTO, GenericFormUICReadByIdRequestDTO, GenericFormUICUpdateRequestDTO, GenericFormUICCloneRequestDTO, GenericFormUICCloneResponseDTO, GenericFormUICReadConfigByTenantIdRequestDTO } from "./form-uic.interface";
import { map, Observable } from "rxjs";
import { GenericFormUIC_Create, GenericFormUIC_Delete, GenericFormUIC_ReadAll, GenericFormUIC_ReadByTenantId, GenericFormUIC_ReadById, GenericFormUIC_Update, GenericFormUIC_Clone, GenericFormUIC_ReadConfigByTenantId } from "src/app/GlobalVariables";
import { lowercaseFirstLetter } from "src/app/Shared/customFunctions/CustomFunctions";
import { resolveTenantUrl, tenantOverrideOptions } from "src/app/Common/ApiConfigurationService/resolve-tenant-url.util";

@Injectable({
    providedIn: 'root'
})
export class GenericFormUICService {

    http = inject(HttpClient)

    // baseUrlOverride/companyId/branchId (all optional): GenericFormUIC config
    // does not live on the Identity Server (confirmed live - unlike
    // CompanyMaster/Roles/etc, routing this via apig.advin.in does not work),
    // so every operation here - reads AND writes - needs to go directly to
    // the selected tenant's own gateway with that tenant's own
    // CompanyId/BranchId headers. Omitted for every other caller - behaves
    // exactly as before.
    GenericFormUIC_Create(data: GenericFormUICCreateRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GenericFormUICDTO> {
        return this.http.post<GenericFormUICDTO>(resolveTenantUrl(GenericFormUIC_Create, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }
    GenericFormUIC_Update(data: GenericFormUICUpdateRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GenericFormUICDTO> {
        return this.http.post<GenericFormUICDTO>(resolveTenantUrl(GenericFormUIC_Update, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }
    GenericFormUIC_Delete(data: GenericFormUICDeleteRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<void> {
        return this.http.post<void>(resolveTenantUrl(GenericFormUIC_Delete, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }
    GenericFormUIC_ReadByTenantId(data: GenericFormUICReadByTenantIdRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GenericFormUICList> {
        return this.http.post<GenericFormUICList>(resolveTenantUrl(GenericFormUIC_ReadByTenantId, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0))
            .pipe(
                map((res) => ({
                    ...res,
                    items: res.items.map(i => ({
                        ...i,
                        dbFeildName: lowercaseFirstLetter(i.dbFeildName)
                    }))
                }))
            );
    }
    GenericFormUIC_ReadById(data: GenericFormUICReadByIdRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GenericFormUICDTO> {
        return this.http.post<any>(resolveTenantUrl(GenericFormUIC_ReadById, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }
    GenericListUIC_ReadAll(data: GenericFormUICReadAllRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GenericFormUICList> {
        return this.http.post<GenericFormUICList>(resolveTenantUrl(GenericFormUIC_ReadAll, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }
    GenericFormUIC_Clone(data: GenericFormUICCloneRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GenericFormUICCloneResponseDTO> {
        return this.http.post<GenericFormUICCloneResponseDTO>(resolveTenantUrl(GenericFormUIC_Clone, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }

    GenericFormUIC_ReadConfigByTenantId(data: GenericFormUICReadConfigByTenantIdRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GenericFormUICList> {
        return this.http.post<GenericFormUICList>(resolveTenantUrl(GenericFormUIC_ReadConfigByTenantId, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0))
            .pipe(
                map((res) => ({
                    ...res,
                    items: res.items.map(i => ({
                        ...i,
                        dbFeildName: lowercaseFirstLetter(i.dbFeildName)
                    }))
                }))
            );
    }

}
